//Archivo dedicado al menu de todos los imports de Sistema de Sentencias

//Imports relacionados de Notificadores
//-----------Principal-----------
import Plantilla from '@/components/SICSEN/Comun/Plantilla.vue';

//-----------Administración-----------
import AltaBajaCambiosSentencias from '@/components/SICSEN/Administracion/Sentencias.vue';
import AltaSentencias from '@/components/SICSEN/Administracion/SentenciasLaborales.vue';
import BajaCambiosSentencias from '@/components/SICSEN/Administracion/Sentencias.vue';

//-----------Consulta-----------
import ConsultaPublicaSentencias from '@/components/SICSEN/Consulta/ConsultaPublicaSentencias.vue';

//Se crea la lista de paths
const SICSEN = [
    {
      name: 'SICSEN', path: '/SICSEN/', component: Plantilla, meta: { tituloDeLaPagina: "Sistema de Control de Sentencias", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 31 }, children: [
        { 
          name: 'AltaBajaCambiosSentencias', 
          path: 'AltaBajaCambiosSentencias', 
          component: AltaBajaCambiosSentencias, 
          meta: { 
              tituloDeLaPagina: "Alta, Baja y Cambios de Sentencias", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 31, 
              ModuloId: 1,
              FuncionId: 1
          },               
        },
        { 
          name: 'ConsultaPublicaSentencias', 
          path: 'ConsultaPublicaSentencias', 
          component: ConsultaPublicaSentencias, 
          meta: { 
              tituloDeLaPagina: "Consulta Pública de Sentencias", 
              RequiereAutenticacion: false, 
              ValidaSesion: false, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 31, 
              ModuloId: 2,
              FuncionId: 2
            }             
        },
        { 
          name: 'AltaSentencias', 
          path: 'AltaSentencias', 
          component: AltaSentencias, 
          meta: { 
              tituloDeLaPagina: "Alta de Sentencias", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 31, 
              ModuloId: 1,
              FuncionId: 3
          },               
        },
        ,
        { 
          name: 'BajaCambiosSentencias', 
          path: 'BajaCambiosSentencias', 
          component: BajaCambiosSentencias, 
          meta: { 
              tituloDeLaPagina: "Baja y Cambios de Sentencias", 
              RequiereAutenticacion: true, 
              ValidaSesion: true, 
              ObtenDatos: true, 
              ObtenPermisosDelSistema: true, 
              SistemaQueSeIngreso: 31, 
              ModuloId: 1,
              FuncionId: 4
          },               
        }
      ]
    }
]

export default SICSEN;


// WEBPACK FOOTER //
// ./src/router/SICSEN.js